import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Button } from '../ui/Button';
export function FooterSection() {
  return <section className="py-24 bg-[#FAF7F2] text-center" data-id="element-105">
      <div className="max-w-2xl mx-auto px-6 lg:px-8" data-id="element-106">
        <FadeIn data-id="element-107">
          <div className="space-y-8 text-xl md:text-2xl font-serif text-[#8B7355] leading-relaxed mb-16" data-id="element-108">
            <p data-id="element-109">Hay un momento en el que una mujer deja de empujarse...</p>
            <p className="italic" data-id="element-110">y empieza a sostenerse.</p>
          </div>

          <div className="space-y-6 text-lg text-[#4A3F35] mb-16" data-id="element-111">
            <p data-id="element-112">Este ebook no te pide que seas otra persona.</p>
            <p data-id="element-113">Solo te invita a volver a tu centro, un día a la vez.</p>
            <p className="font-medium mt-8" data-id="element-114">Si lo sientes, aquí estoy.</p>
          </div>

          <div className="mb-16" data-id="element-115">
            <Button href="#comprar" className="px-10 py-5 text-xl mb-6" data-id="element-116">
              Escríbeme "CENTRO" y te lo envío
            </Button>
            <p className="font-serif text-2xl text-[#8B7355] mt-8" data-id="element-117">Hoy Pleno</p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-118">
          <div className="border-t border-[#E8E0D5] pt-12 mt-12 text-left bg-white p-8 rounded-2xl shadow-sm" data-id="element-119">
            <p className="font-bold text-[#8B7355] mb-2" data-id="element-120">P.D.</p>
            <p className="text-lg text-[#6B5C4D]" data-id="element-121">
              Si estás viviendo un día pesado, no esperes a "sentirte lista". A
              veces la calma llega <strong data-id="element-122">después</strong> de dar el primer
              paso suave.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}